var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileOptionSelector',{attrs:{"model":'jobCategory',"nextRoute":function (item) { return (item.verification_required ? 'CompanyPage' : 'JobPage'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }